var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconFolderAdd = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", stroke: props.color, strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("path", { d: "M12.8,24.8H6.3 c-1.2,0-2.2-1-2.2-2.2V7.4c0-1.2,1-2.2,2.2-2.2h5.4l2.2,3.3h9.8c1.2,0,2.2,1,2.2,2.2v2.8" }),
            React.createElement("path", { d: "M25.8,20" }),
            React.createElement("path", { d: "M25.8,13.4" }),
            React.createElement("g", { transform: "translate(-1.083 -1.083)" },
                React.createElement("path", { strokeWidth: "1", d: "M29.5,21c0,4.6-3.8,8.4-8.4,8.4s-8.4-3.8-8.4-8.4s3.8-8.4,8.4-8.4S29.5,16.4,29.5,21L29.5,21z" })),
            React.createElement("g", { transform: "translate(-4.333 -4.333)" },
                React.createElement("path", { d: "M24.4,19.5v9.5" }),
                React.createElement("path", { d: "M19.6,24.3h9.5" })))));
});
export default IconFolderAdd;
//# sourceMappingURL=IconFolderAdd.js.map